import UserDB from '@/firebase/users-db';

export default {
    async clearData({ commit }) {
        commit('SET_CURRENTUSER', null, { root: true });
        commit('SET_USERPROFILE', null, { root: true });
        commit('posts/SET_POSTS', null, { root: true });
        commit('posts/products', null, { root: true });
    },
    setnull({ state }) {
        state.userProfile.last_position = Number(0);
    },
    deleteOne({ state }) {
        state.userProfile.last_position = Number(-1);
    },
    /**
     * update userName }
     */
    updateUserName: async({ commit, rootState }, payload) => {
        const userId = rootState.user.currentUser.uid;
        const userProductDb = new UserDB(userId);

        await userProductDb.updateInside(payload.selectedContent, payload.path, userId);
        state.user.userProfile.general.name = payload.selectedContent
    },

    triggerUpdateName: ({ dispatch }, payload) => {
        dispatch('updateUserName', payload);
    },
    /** 
     * change password
     */
    updatePassword: async({ commit, rootState }, payload) => {

    },

    triggerUpdatePassword: ({ dispatch }, payload) => {
        dispatch('updatePassword', payload);
    },
};